import React from 'react';
import cx from 'classnames';

import iconAccessibility from '../utils/iconAccessibility';
import styles from './Icons.module.scss';

export interface Props {
  accessibilityLabel?: string;
  className?: Parameters<typeof cx>[0];
}

export const ChevronS2Right: React.FC<Props> = ({
  accessibilityLabel,
  className,
}) => (
  <i className={cx(styles.icon, className)}>
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      {...iconAccessibility(accessibilityLabel)}
    >
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0h24v24H0z' />
        <path
          fill='currentColor'
          d='M11.55 15.54l-1.06-1.06 2.47-2.47-2.47-2.47 1.06-1.06 3.53 3.53z'
        />
      </g>
    </svg>
  </i>
);

ChevronS2Right.displayName = 'ChevronS2Right';
export default ChevronS2Right;
